<template>
	<div class="media widthz">
		<div class="navGo flex  ">
			<span @click="goHomg()">首页></span>
			<span>详情</span>
		</div>

		<section class="widthWhite">
			<hgroup>
				<h6>{{ detail.Title }}</h6>
				<div class="flexCenter">
					<p class="flex zhong center">
						<span>浏览量: {{ detail.Scan }}</span>
						发布日期: {{ detail.CreateTime }}
						<span></span>
					</p>
					<div class="fg_div flex zhong">
						<img :src="detail.UserAttention?require('../../image/san/wxbba.png'):require('../../image/san/wxb.png')"
							v-on:click="AttentionAdd" />
						<img src="../../image/san/wxa.png" @click="isPOP = true" />
					</div>
				</div>
			</hgroup>
			<article class="details_nei" id="detailInfo"></article>
		</section>

		<!-- pop -->
		<aside class="popup flexCenter" v-if="isPOP">
			<div class="bai">
				<p class="baia">分享到微信朋友圈</p>
				<div class="bai_img">
					<!-- <img src="../../image/banner.png" /> -->
					<vue-qr :value="shareUrl" :options="{size: 160}"></vue-qr>
				</div>
				<p class="baib">打开微信，点击底部的"发现"</p>
				<p class="baib">使用"扫一扫"即可将网页分享至朋友圈</p>
				<button type="button" class="btn" @click="isPOP = false">关闭</button>
			</div>
		</aside>
	</div>
</template>
<script>
	import vueQr from '@xkeshi/vue-qrcode';
	export default {
		name: 'media',
		data() {
			return {
				isPOP: false,
				detailId: 0,
				detail: {},
				newsTitle: '媒体报道',
				userInfo: {},
				baseUrl:''
			};
		},
		components: {
			vueQr
		},
		mounted() {
			console.log('页面传参' + this.$route.query);
			this.detailId = this.$route.query.Id ? this.$route.query.Id : 0;
			this.shareUrl=process.env.VUE_APP_BASE_API+'h5/#/mediaDetails?Id='+this.detailId;
			console.log('this.shareUrl', this.shareUrl);
			this.GetDetail();
			this.GetNewsTitle();
			this.GetUserInfo();
		},
		methods: {
			// 返回首页
			goHomg() {
				this.$router.push('/home');
			},
			// 返回
			goBack() {
				this.$router.push('/media');
			},
			// 获取详情
			GetDetail: function() {
				var that = this;
				const loading = this.$loading({
					lock: true
				});
				that.$api.HtppRequest(
					'WebsiteSet/GetReportDetail?Id=' + that.detailId,
					'GET', {},
					function(res) {
						console.log('获取详情');
						console.log(res);
						if (res.code === 0) {
							that.detail = res.data;
							document.getElementById('detailInfo').innerHTML = res.data.Detail;
						}
						loading.close();
					},
					function(res) {
						loading.close();
					}
				);
			},
			// 获取新闻标题
			GetNewsTitle: function() {
				var that = this;
				that.$api.HtppRequest(
					'WebsiteSet/GetNewsTitle',
					'GET', {},
					function(res) {
						console.log('获取新闻标题');
						console.log(res);
						if (res.code === 0) {
							that.newsTitle = res.data;
						}
					},
					function(res) {}
				);
			},
			// 添加或取消关注
			AttentionAdd: function() {
				var that = this;
				// ContentId 院校/专业数据Id 课程Id/文章Id
				// Type 1=院校 2=专业 3=课程 4=文章
				that.$api.HtppRequest(
					'Accurate/AttentionAdd?UserId=' + that.userInfo.Id + '&ContentId=' + this.detailId + '&Type=4',
					'GET', {},
					function(res) {
						console.log('添加或取消关注');
						console.log(res);
						if (res.code === 0) {
							that.newsTitle = res.data;
							that.detail.UserAttention = !that.detail.UserAttention;
							that.$util.showOk(res.msg);
						} else {
							that.$util.showError(res.msg);
						}
					},
					function(res) {}
				);
				this.isShouicon = !this.isShouicon;
			},
			// 获取用户信息
			GetUserInfo: function() {
				var that = this;
				that.$api.HtppRequest(
					'User',
					'GET', {},
					function(res) {
						console.log('获取用户信息');
						console.log(res);
						if (res.code === 0) {
							that.userInfo = res.data;
						}
					},
					function(res) {}
				);
			}

		}
	};
</script>
<style scoped>
	.btn {
		width: 200px;
		height: 40px;
		border-radius: 6px;
		font-size: 14px;
		display: block;
		margin: 40px auto 0 auto;
		color: #fff;
		text-align: center;
		line-height: 40px;
		background-color: #444444;
		cursor: pointer;
	}

	.baib {
		text-align: center;
		font-size: 14px;
		color: #666666;
	}

	.bai_img img {
		display: block;
		width: 100%;
		height: 100%;
	}

	.bai_img {
		width: 190px;
		height: 190px;
		padding: 15px;
		background-color: #fafafa;
		margin: 25px auto;
	}

	.baia {
		text-align: center;
		font-size: 14px;
		color: #000;
	}

	.bai {
		border-radius: 10px;
		width: 515px;
		background-color: #fff;
		padding: 20px 0;
	}

	.fg_div img {
		display: block;
		width: 32px;
		height: 32px;
		margin-left: 20px;
		cursor: pointer;
		margin-top: 20px;
	}

	.navGo {
		position: relative;
	}

	.details_nei {
		font-size: 14px;
	}

	.widthWhite hgroup p span {
		margin: 0 20px;
	}

	.widthWhite hgroup p {
		margin-top: 20px;
		font-size: 12px;
		color: #666;
	}

	.widthWhite hgroup h6 {
		font-weight: normal;
		font-size: 16px;
		text-align: center;
	}

	.widthWhite hgroup {
		padding: 0 0 20px 0;
		margin-bottom: 20px;
		border-bottom: solid 1px #e6e6e6;
	}
</style>
